const Shield = ({ stroke = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      d="M8 1.5L2.5 3.5v4.7c0 3 2.3 5.5 5.5 6.3 3.2-.8 5.5-3.3 5.5-6.3V3.5z"
      stroke={stroke}
      strokeWidth="1.4"
      strokeLinejoin="round"
    />
    <path
      d="M5.6 8l1.7 1.7L10.4 6.5"
      stroke={stroke}
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Shield;
